import dayjs from 'dayjs'

/**
 * 移动排班 - 常量
 */
export const WeekdayUpper: string[] = ['日', '一', '二', '三', '四', '五', '六']
// 排班色块颜色
export const SchedulePrimaryColor = '#5789FF'
// 键值对
export const AssistMap: any = { 0: '未调', 1: '调入', 2: '调出' }
export const StatusMap: any = { 1: '正常', 2: '未入职', 3: '已离职' }
export const HealthMap: any = { 0: '健康证失效', 1: '健康证有效' }
export const defaultPageSize = 20

// 排班周期类型
export const SCHEDULE_PERIOD_TYPE: Record<string, string> = {
  MONTH: 'MONTH',
  DAY: 'DAY',
  WEEK: 'WEEK',
  CUSTOM: 'CUSTOM',
  PERIOD: 'PERIOD'
}

/**
 * 字段映射（移动排班设置）
 */
export const FieldsMap: any = {
  schedule_employee_info_settings: {
    EMPLOYEE_NAME: 'name',
    EMPLOYEE_ARRANGED_WORK_HOUR: '({scheduled_hours}小时)',
    EMPLOYEE_NO: 'person_number',
    EMPLOYEE_ORG: 'org_name',
    EMPLOYEE_JOB_TYPE: 'job_type_name',
    EMPLOYEE_POST: 'post_name',
    EMPLOYEE_POSITION: 'position_name',
    EMPLOYEE_MONTHLY_QUOTA_HOURS: '({period_quota_minutes}分钟)',
    EMPLOYEE_BILLABLE_WORK_HOURS: '({billable_work_hours}小时)'
  },
  schedule_shift_toolbar_content: {
    SHIFT_NAME: 'schedule_shift_name',
    SHIFT_CODE: 'schedule_shift_code',
    SHIFT_PERIOD: 'display_time',
    SHIFT_COMPLETE_PERIOD: 'display_complete_time',
    SHIFT_QUOTA: '({scheduled_hours}小时)'
  }
}

/**
 * 字段映射（移动排班设置）for List
 */
export const FieldsMapForList = {
  schedule_shift_toolbar_content: {
    SHIFT_NAME: 'name',
    SHIFT_CODE: 'code',
    SHIFT_COMPLETE_PERIOD: 'time_interval_list.tip',
    SHIFT_PERIOD: 'display_time',
    SHIFT_QUOTA: '{scheduled_hours}小时'
  }
}

export const FieldsLocalMap: any = {
  classes: {
    name: 'schedule_shift_name',
    code: 'schedule_shift_code'
  },
  timeline: {
    type_name: 'slot_owner_name',
    tip: 'display_time',
    tip_work: 'scheduled_hours'
  },
  location: {
    id: 'work_location_id',
    code: 'work_location_code',
    name: 'work_location_name'
  },
  datetype: {
    value: 'date_type_code',
    name: 'date_type_name'
  }
}

export const WeekdayUpperCn: string[] = ['一', '二', '三', '四', '五', '六', '日']

export function getWeekdayDate(days: number) {
  return dayjs('2024-01-01').add(days, 'day').format('YYYY-MM-DD')
}
export const getLocalRowData = (days: number, mergeObject?: any, sort = 0) => {
  const rowData = {
    sort,
    employee_id: sort,
    reference_count: 1,
    plan_results: Array.from({ length: days }, (_, i) => {
      return {
        schedule_date: getWeekdayDate(i),
        schedule_plans: []
      }
    })
  }
  return mergeObject
    ? {
        ...mergeObject,
        ...rowData,
        plan_results: mergeObject?.plan_results
      }
    : rowData
}
export const LineScaleWidth = 48
// 生成划线班时长
export const LineShiftMinutes = 120

export const TIMEUNIT_CN = {
  hour: '小时',
  minute: '分钟'
}
export const TIMEUNIT_EN = {
  hour: 'h',
  minute: 'm'
}
export const TIMEUNIT = TIMEUNIT_EN
export const DRAG_ORIGIN_OPACITY = 0.4
export const DRAG_MOVE_ORIGIN_OPACITY = 0.4
export const DRAG_BOUNDARY_THRESHOLD = 20
export const AUTO_SCROLL_BOUNDARY_THRESHOLD = 100
export const isScheduleNoPermission = (setting?: any) => {
  const {
    schedule_shift_scheduling_flag = 1,
    schedule_preset_shift_scheduling_flag = 1,
    schedule_assign_position_level_flag = 1,
    schedule_assign_task_flag = 1,
    schedule_assign_work_location_flag = 1
  } = setting || {}
  return (
    !schedule_shift_scheduling_flag &&
    !schedule_preset_shift_scheduling_flag &&
    !schedule_assign_position_level_flag &&
    !schedule_assign_task_flag &&
    !schedule_assign_work_location_flag
  )
}
